import {
    FEES_FAILURE as FAILURE,
    FEES_REQUEST as REQUEST,
    FEES_SUCCESS as SUCCESS,
} from 'actions';
import preserveArrayReference from 'utils/Array/preserveArrayReference';

const initialState = {
    data: [],
    isFetched: false,
    isFetching: false,
};

export const feeListReducer = (state = initialState, action) => {
    const {type, data} = action;
    switch (type) {
        case SUCCESS: {return {
            ...state,
            isFetched: true,
            isFetching: false,
            data: preserveArrayReference(state.data, data),
        }}

        case REQUEST: {return {
            ...state,
            isFetching: true,
        }}

        case FAILURE: {return {
            ...state,
            isFetching: false,
        }}

        default: {return state}
    }
};
